// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderhistory-container {
    margin-top: 20px;
    margin-bottom: 20px;
}

.orderhistory-title {
    font-size: 20px;
    margin-bottom: 15px;
    text-align: center;
    font-family: "Rigidica Text Regular", sans-serif;
}

.orderhistory-list {
    margin-bottom: 20px;
}

.orderhistory-item {
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
    transition: box-shadow 0.3s ease;
}

.orderhistory-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.orderhistory-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.orderhistory-id {
    font-weight: bold;
    font-size: 16px;
}

.orderhistory-status {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: bold;
}

.orderhistory-status-pending {
    background-color: #fff3cd;
    color: #856404;
}

.orderhistory-status-shipped {
    background-color: #d4edda;
    color: #155724;
}

.orderhistory-status-returned {
    background-color: #f8d7da;
    color: #721c24;
}

.orderhistory-date,
.orderhistory-items-summary,
.orderhistory-total,
.orderhistory-product-ids {
    margin-bottom: 8px;
    font-size: 14px;
}

.orderhistory-product-id {
    font-family: monospace;
    background-color: #f5f5f5;
    padding: 2px 4px;
    margin-right: 3px;
    border-radius: 3px;
    font-size: 12px;
}

.orderhistory-label {
    font-weight: bold;
    margin-right: 5px;
}

.orderhistory-address {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 15px;
}

.orderhistory-address-details {
    margin-top: 5px;
    padding-left: 10px;
    border-left: 2px solid #ddd;
}

.orderhistory-view-button {
    display: block;
    margin-top: 10px;
    padding: 8px 15px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s;
    width: fit-content;
    margin-left: auto;
}

.orderhistory-view-button:hover {
    background-color: #555;
}

.orderhistory-no-orders {
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 6px;
    font-style: italic;
    color: #666;
}

.orderhistory-loading {
    text-align: center;
    padding: 20px;
    color: #666;
}

.orderhistory-error {
    color: #ff0000;
    margin-bottom: 15px;
    text-align: center;
    padding: 10px;
    background-color: #ffeeee;
    border: 1px solid #ff0000;
    border-radius: 4px;
}

.orderhistory-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
}

.orderhistory-pagination-button {
    background-color: #333;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    min-width: 40px;
}

.orderhistory-pagination-button:hover:not(:disabled) {
    background-color: #555;
}

.orderhistory-pagination-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.orderhistory-page-indicator {
    padding: 8px 15px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    min-width: 80px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/OrderHistory.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,gDAAgD;IAChD,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".orderhistory-container {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.orderhistory-title {\n    font-size: 20px;\n    margin-bottom: 15px;\n    text-align: center;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.orderhistory-list {\n    margin-bottom: 20px;\n}\n\n.orderhistory-item {\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 15px;\n    margin-bottom: 15px;\n    transition: box-shadow 0.3s ease;\n}\n\n.orderhistory-item:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.orderhistory-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eee;\n}\n\n.orderhistory-id {\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.orderhistory-status {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.orderhistory-status-pending {\n    background-color: #fff3cd;\n    color: #856404;\n}\n\n.orderhistory-status-shipped {\n    background-color: #d4edda;\n    color: #155724;\n}\n\n.orderhistory-status-returned {\n    background-color: #f8d7da;\n    color: #721c24;\n}\n\n.orderhistory-date,\n.orderhistory-items-summary,\n.orderhistory-total,\n.orderhistory-product-ids {\n    margin-bottom: 8px;\n    font-size: 14px;\n}\n\n.orderhistory-product-id {\n    font-family: monospace;\n    background-color: #f5f5f5;\n    padding: 2px 4px;\n    margin-right: 3px;\n    border-radius: 3px;\n    font-size: 12px;\n}\n\n.orderhistory-label {\n    font-weight: bold;\n    margin-right: 5px;\n}\n\n.orderhistory-address {\n    font-size: 14px;\n    margin-top: 10px;\n    margin-bottom: 15px;\n}\n\n.orderhistory-address-details {\n    margin-top: 5px;\n    padding-left: 10px;\n    border-left: 2px solid #ddd;\n}\n\n.orderhistory-view-button {\n    display: block;\n    margin-top: 10px;\n    padding: 8px 15px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: fit-content;\n    margin-left: auto;\n}\n\n.orderhistory-view-button:hover {\n    background-color: #555;\n}\n\n.orderhistory-no-orders {\n    text-align: center;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 6px;\n    font-style: italic;\n    color: #666;\n}\n\n.orderhistory-loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n}\n\n.orderhistory-error {\n    color: #ff0000;\n    margin-bottom: 15px;\n    text-align: center;\n    padding: 10px;\n    background-color: #ffeeee;\n    border: 1px solid #ff0000;\n    border-radius: 4px;\n}\n\n.orderhistory-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    gap: 10px;\n}\n\n.orderhistory-pagination-button {\n    background-color: #333;\n    color: white;\n    border: none;\n    padding: 8px 15px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    min-width: 40px;\n}\n\n.orderhistory-pagination-button:hover:not(:disabled) {\n    background-color: #555;\n}\n\n.orderhistory-pagination-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.orderhistory-page-indicator {\n    padding: 8px 15px;\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: bold;\n    min-width: 80px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
